import { SubLayout } from '@/components/layouts'
const routes = {
  path: '/product',
  redirect: '/product/productList',
  component: SubLayout,
  children: [
    {
      path: 'productAdjust',
      name: 'productAdjust',
      meta: {
        title: '一键调价'
      },
      component: () => import('@/views/product/Adjust')
    },
    {
      path: 'productList',
      name: 'productList',
      meta: {
        title: '商品'
      },
      component: () => import('@/views/product/Index')
    }
  ]
}

export default routes
